import { usePollingQuery } from '../usePollingQuery'
import { fetchOrderPaymentStatus } from '../../repository/mfExecution'
import { PaymentStatus } from '../../types/mf-execution.types'
import { useSearchParams } from 'react-router-dom'
import useTimer from '../useTimer'

export const useOrderPaymentStatusQuery = ({ maxTimer }: { maxTimer: number }) => {
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('orderId')
  const { isExpired, timeLeft } = useTimer({ maxTimer })
  const {
    data: paymentStatus,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isError
  } = usePollingQuery({
    queryKey: ['orderPaymentStatus', orderId],
    queryFn: () => fetchOrderPaymentStatus(orderId as string),
    enabled: !!orderId,
    shouldPoll: (data, error) => {
      // Only poll if status is AWAITING and we're not in error state
      const currentStatus = data?.status
      const isInErrorState = error !== null
      return currentStatus === PaymentStatus.AWAITING && !isInErrorState && !isExpired
    },
    pollInterval: 2000
  })

  return {
    paymentStatus,
    isError,
    isLoading,
    isFetching,
    isSuccess,
    isFetched,
    isExpired,
    timeLeft
  }
}
